const IMPORT_SUBMITTED_ROUTE_REGEX = /^\/workspaces\/(\d+)\/journeys\/imports\/\d+\/setup\/importing(?:[/?#]|$)/;

/**
 * The Ember imports wizard lands on `.../setup/importing` the moment a CSV
 * import is submitted, so that URL is the "finished uploading" signal. Returns
 * the workspace the import belongs to, or null for every other route.
 */
export function getImportSubmittedWorkspaceId(url: string): number | null {
  const match = IMPORT_SUBMITTED_ROUTE_REGEX.exec(url);
  if (match == null) {
    return null;
  }
  return Number(match[1]);
}
